import RunJob from '../../../../components/RunJob/RunJob'

import {usePipelineRunJob} from './PipelineRunJob.hooks'

import type {BuildId} from 'src/types'

type Props = {
  x: number
  y: number
  jobId: BuildId
}

export default function PipelineRunJob({x, y, jobId}: Props) {
  const {job, icon, parallelTestsRuns, selectedJobId, isJobReused} = usePipelineRunJob(jobId)
  const runningInfo = job?.['running-info']

  return (
    <RunJob
      x={x}
      y={y}
      jobId={jobId}
      runningInfo={runningInfo}
      isJobReused={isJobReused}
      parallelTestsRuns={parallelTestsRuns}
      selectedJobId={selectedJobId}
      icon={icon}
      to={{search: jobId === selectedJobId ? '' : `job=${jobId}`}}
      replace
      {...job}
    />
  )
}
